const noop = () => undefined;

export const RadioBlock = {
	functional: true,
	props: {
		name: String,
		value: String,
		label: String,
		checked: Boolean,
		required: Boolean,
	},
	render(h, {
		props: {
			name,
			value,
			label,
			checked,
			required,
		},
		listeners: {
			onChange,
		},
		data,
		slots,
	}) {
		return (
			<label class="radio-block" { ...data }>
				<input
					class="radio-block__input"
					type="radio"
					name={ name }
					value={ value }
					checked={ checked }
					onChange={ onChange ?? noop }
					required={ required }
				/>
				<svg class="radio radio-block__radio" viewBox="-9 -9 18 18">
					<circle class="radio__bullet" r="5" />
				</svg>
				{ (label || slots().label) ? (
					<span class="label checkbox-block__label">
						{ label || slots().label }
					</span>
				) : null }
				</label>
		)
	}
}
